import Lenis from 'lenis'

export const lenis = new Lenis({ lerp: 0.1, smoothWheel: true })

export function initLenis() {
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  // Scroll progress line
  lenis.on('scroll', ({ scroll }) => {
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const progress = docHeight > 0 ? scroll / docHeight : 0
    const el = document.querySelector('.scroll-progress')
    if (el) el.style.transform = `scaleX(${progress})`
  })

  // Scroll velocity skew
  lenis.on('scroll', ({ velocity }) => {
    const skew = Math.max(-1.5, Math.min(1.5, velocity * 0.02))
    document.querySelectorAll('.skew-on-scroll').forEach((el) => {
      el.style.transform = `skewY(${skew}deg)`
    })
  })
}
